import axios from "@/utils/request";
// 验证验证码
export function checkVerificationCode(data) {
  return axios({
    url: `/college_service_hall_api/verificationCode/checkVerificationCode`,
    method: "post",
    data,
  });
}
// 生成验证码
export function generateVerificationCode(data) {
  return axios({
    url: `/college_service_hall_api/verificationCode/generateVerificationCode`,
    method: "post",
    data,
  });
}
// 立即登录
export function isLogin(data) {
  return axios({
    url: `/college_service_hall_api/oauth2/doLogin`,
    method: "get",
    params: data,
  });
}

// 退出
export function signout(data) {
  return axios({
    url: `/college_service_hall_api/oauth2/logOut`,
    method: "post",
    data,
  });
}
// 菜单权限
export function getUserPage(params) {
  return axios({
    url: `/college_service_hall_api/oauth2/self/getUserPage`,
    method: "post",
    params,
  });
}
// 用户信息
export function userinfo() {
  return axios({
    url: `/college_service_hall_api/oauth2/self/userinfo`,
    method: "post",
  });
}
// 同意
export function doConfirm(data) {
  return axios({
    url: `/college_service_hall_api/oauth2/doConfirm`,
    method: "get",
    params: data,
  });
}
// 待办任务
export function toDoList(params) {
  return axios({
    url: `/college_service_hall_api/home/to-do/list`,
    method: "post",
    params,
  });
}
// 通知公告
export function noticeOpen(params) {
  return axios({
    url: `/college_service_hall_api/system/notice/web/list`,
    method: "post",
    params,
  });
}
// 通知公告 新* 我已知晓
export function iGotIt(params) {
  return axios({
    url: `/college_service_hall_api/system/notice/web/iGotIt`,
    method: "post",
    params,
  });
}
//通知公告 新* 获取开屏通知列表
export function noticeOpenShow(params) {
  return axios({
    url: `/college_service_hall_api/system/notice/web/open`,
    method: "post",
    params,
  });
}
// 待办任务
export function readMessageApi(id) {
  return axios({
    url: `/college_service_hall_api/home/my/readMessage`,
    method: "post",
    params:{id},
  });
}
// 用户自己修改自己的密码
export function updateMyPassword(data) {
  return axios({
    url: `/college_service_hall_api/system/user/update-my-password`,
    method: "post",
    data
  });
}
// 注册用户
export function register(data) {
  return axios({
    url: `/college_service_hall_api/system/user/register`,
    method: "post",
    data,
  });
}
// 查询待审核分页
export function getNeedPageList(data) {
  return axios({
    url: `/college_service_hall_api/sysUserLog/getNeedPageList`,
    method: "post",
    data,
  });
}
//注册用户审核
export function userHandle(data) {
  return axios({
    url: `/college_service_hall_api/sysUserLog/userHandle`,
    method: "post",
    data,
  });
}
//根据手机号查询注册记录列表
export function getRegisterListBy(params) {
  return axios({
    url: `/college_service_hall_api/system/user/getRegisterListBy`,
    method: "post",
    params,
  });
}
// 获取我的详情
export function getMyInfo() {
  return axios({
    url: `/college_service_hall_api/home/getMyInfo`,
    method: "post",
  });
}
// 获取我的详情
export function updateMyInfo(data) {
  return axios({
    url: `/college_service_hall_api/home/updateMyInfo`,
    method: "post",
    data
  });
}
// 修改我的详情
export function directoryUpdate(data) {
  return axios({
    url: `/college_service_hall_api/system/directory/update`,
    method: "post",
    data
  });
}
